import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-slurry-material-errors',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './slurry-material-errors.component.html'
})
export class SlurryMaterialErrorsComponent {
  @Input() errors: string[] = [];
}
